export const DIET_FACET_ORDER = [
  'Pescatarian',
  'Vegetarian',
  'Vegan',
  'Gluten-free',
  'Keto',
  'Low calorie',
  'Low carb',
  'Low fat',
];

export const DIET_FACET_HIDDEN = [
  'Low sodium',
  'High protein',
  'Low sugar',
  'High fibre',
  'Diabetic',
  'Heart health',
  'Very low sodium',
];
